// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__J_nkA","big":"big__vyCZN","inner":"inner__2MasZ","content":"content__3vwEv","headline":"headline__IdAQq","buttonWrapper":"buttonWrapper__kq5So"};


//////////////////
// WEBPACK FOOTER
// ./components/promo/styles.scss
// module id = 6IS5
// module chunks = 1